import {AbstractSearchCore} from "./AbstractSearchCore";
import {AbstractSubscriber} from "./AbstractSubscriber";
import {IFacet} from "./IFacet";
import {IResult} from "./IResult";

export class SearchBarSubscriber extends AbstractSubscriber {
  core: AbstractSearchCore | undefined;
  _updateCallback: (query: string) => void;
  constructor(groupId: string, updateCallback: (query: string) => void) {
    super(groupId);
    this._updateCallback = updateCallback;
  }
  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this.core = searchCore;
  }

  public doSearch(myString: string) {
    this.core?.executeSearch(myString);
  }

  detaching(): void {
  }

  onFacetUpdate(facets: IFacet[]): Promise<void> {
    console.log(facets);
    return Promise.resolve(undefined);
  }

  onSearchTextUpdate(text: string): Promise<void> {
    this._updateCallback(text)
    return Promise.resolve(undefined);
  }

  onResultUpdate(result: IResult): Promise<void> {
    console.log(result);
    return Promise.resolve(undefined);
  }
}